export default __webpack_public_path__ + "static/media/access_detained.206327bb.svg";